import { connect } from 'react-redux';
//
import ModalProvider from 'components/modal-provider/modal-provider';
import { IStoreState } from 'store';
import { clearModalContent } from 'store/modal/actions';

const mapStateToProps = ({ modal }: IStoreState) => ({
  ...modal,
});

const mapDispatchToProps = {
  clearModalContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalProvider);
